import React, { Fragment, useCallback } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import replaceLocation from '../../../utils/replaceLocation'
import CommonImageContainer from './commons/CommonImageContainer'

import getGatsbyImage from '../../../utils/getGatsbyImage'

export default function LoggingButtonSection({
  slice,
}: {
  slice: Queries.PrismicPageDataBodyLoggingButton
}) {
  const item = slice.primary
  const image = getGatsbyImage(item.logging_button_image?.localFile)
  const handleClickImage = useCallback((url: string) => {
    if (url) {
      replaceLocation(url)
    }
  }, [])
  return (
    <Fragment>
      <CommonImageContainer
        onClick={() => {
          if (item.logging_button_web_modal_text) {
            alert(item.logging_button_web_modal_text)
          }
          if (item.logging_button_web_link) {
            handleClickImage(item.logging_button_web_link)
          }
        }}
      >
        {image && (
          <GatsbyImage
            image={image}
            alt={item.logging_button_image?.alt || ''}
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        )}
      </CommonImageContainer>
    </Fragment>
  )
}
